import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import foodbrand from "../assets/foodbrand@2x.png";
import Modal from 'react-bootstrap/Modal';

function HomeConocimientoVial() {

  const navigate = useNavigate();
  const [strCPV, setStrCPV] = useState("");
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState('');

  const handleClose = () => {
    setShow(false);
  }

  useEffect(() => {
    setStrCPV(localStorage.getItem("sCpv"));
  });

  const onTest = async () => {
    navigate("/QuestionConocimientoVial", {
      state: { user: "userTest" },
    });
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/PantallaBase27"
          title="Conocimiento vial"
          name="HomeConicimientoVial"
        />
        <div className="containerRender">
          <div className="containerInfo_P2">
            <div className="containerIdent_P2">
              <div className="txtOp_P2">Operación/Operation</div>
              <div className="txtVer_P2">
                Examen de Conocimiento Vial
              </div>
              <div className="txtCpv_P2">CPV/PVC</div>
              <div className='txtVer_P2'>{strCPV}</div>
              <div className="txtOp_P2">Remitente/Sender</div>
              <div className="txtVer_P2">Business Prey</div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="containerCont_P2">
            <button className="button_P2" onClick={onTest}>
              <span className="txtButton_P2">Iniciar</span>
            </button>
          </div>
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default HomeConocimientoVial;
